import { lineLogin, getLineToken } from '@/services/lineApi.service'

export default {
    namespaced: true,
    state: {
        lineLoginData: {}
    },
    getters: {
        accessToken: (state) => {
            return state.lineLoginData?.access_token ?? ''
        },
        idToken: (state) => {
            return state.lineLoginData?.id_token ?? ''
        },
        refreshToken: (state) => {
            return state.lineLoginData?.refresh_token ?? ''
        },
    },
    mutations: {
        setLineLoginData(state, lineLoginData) {
            state.lineLoginData = lineLoginData;
        }
    },
    actions: {
        login({state},data) {
            console.log(state.lineLoginData)
            lineLogin(data)
        },
        async getToken({commit}, code) {
            const res = await getLineToken(code)
            commit('setLineLoginData', res)
        }
    }
}